import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "unmatched-order" }
const _hoisted_2 = { class: "unmatched-order__title unmatched-order-title" }
const _hoisted_3 = { class: "unmatched-order-title__label" }
const _hoisted_4 = { class: "unmatched-order-title__nav unmatched-order-nav" }
const _hoisted_5 = { class: "unmatched-order__contains" }
const _hoisted_6 = { class: "unmatched-order__head-area" }
const _hoisted_7 = { class: "unmatched-order__head-area--left" }
const _hoisted_8 = { class: "unmatched-order__head-area--right" }
const _hoisted_9 = ["checked", "indeterminate"]
const _hoisted_10 = ["checked", "onChange"]
const _hoisted_11 = { class: "order-status" }
const _hoisted_12 = { class: "error-reason" }

import { i18n } from '@/i18n';
import { onMounted, computed, ref, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { useUnmatchedOrderStore } from './useUnmatchedOrderStore';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import MatchConfirmModal from '../components/MatchConfirmModal.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import RegisterOrderBusinessModal from '../components/RegisterOrderBusinessModal.vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { ERROR_REASON_LABELS, TABLE_HEADERS } from '../constants';
import { OrderBusinessForRegister } from '../domains/entities/UnmatchedOrderItem';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';
import BulkRegisterModal from '../components/BulkRegisterModal.vue';
import TableHeaderModifyButton from '@/corePagesModule/components/TableHeaderModifyButton.vue';
import { useTableHeader } from '@/corePagesModule/composables/useTableHeader';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const t = i18n.t;
const store = useUnmatchedOrderStore();
const { state } = storeToRefs(store);
const {
  init,
  toggleCheck,
  toggleCheckAll,
  onAppliedFilterModal,
  onChangedPaging,
  openMatchModal,
  closeMatchModal,
  matchChecked,
  registerOrderBusiness,
  deleteChecked,
} = store;

const defaultHeaderKeys = TABLE_HEADERS.map((v) => v.key);

const { headerList, updateDisplayHeader } = useTableHeader(defaultHeaderKeys, 'unmatchedOrder');

const errorReasonTableCellRef = ref<InstanceType<typeof EzCell>[]>([]);

const isAllChecked = computed(() => state.value.items.length > 0 && state.value.checkedIds.length === state.value.items.length);
const hasChecked = computed(() => state.value.checkedIds.length > 0);
const hasSingleChecked = computed(() => state.value.checkedIds.length === 1);
const checkedItems = computed(() => state.value.items.filter((item) => state.value.checkedIds.includes(item.unmatchedOrderId)));

const displayHeader = computed(() => TABLE_HEADERS.filter((h) => headerList.value.includes(h.key)));
const gridTemplateColumns = computed(() => displayHeader.value.map((h) => h.width));

const modifiableHeaderList = computed(() => {
  const headerListValue = headerList.value;
  const excludedKeys = new Set(['checkbox', 'headerModify']);

  return defaultHeaderKeys
    .filter((key) => !excludedKeys.has(key))
    .map((key) => {
      let text = TABLE_HEADERS.find((v) => v.key === key)?.label;
      if (!text) {
        return { key, text: 'ERROR', isShown: headerListValue.includes(key) };
      }
      return { key, text, isShown: headerListValue.includes(key) };
    });
});

onMounted(() => {
  init();
});

/**
 * 新規登録ボタンを押した際の処理
 */
const onClickRegisterButton = () => {
  if (hasSingleChecked.value) {
    state.value.registerModalState = true;
  } else if (hasChecked.value) {
    state.value.bulkRegisterModalState = true;
  }
  return;
};

/**
 * 登録モーダルを閉じる処理
 * @param isNext - 次へ進んだか
 * @param info - 登録情報
 */
const onCloseRegisterOrderBusinessModal = async (isNext?: boolean, info?: OrderBusinessForRegister) => {
  state.value.registerModalState = false;
  if (isNext) {
    if (!info) {
      showInfoModal({
        modalTitle: t('エラーが発生しました'),
        modalDescription: t('発注登録中にエラーが発生しました。再度お試しください。'),
        backButtonLabel: t('OK'),
        isDisabledNextButton: true,
        icon: 'error',
      });
      return;
    }
    registerOrderBusiness(info);
  }
};

watch(
  () => i18n.locale,
  async () => {
    await nextTick();
    if (errorReasonTableCellRef.value) errorReasonTableCellRef.value.forEach((r) => r.notifyTooltipContentChange());
  }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('未照合・差異一覧')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          class: "unmatched-order-nav__label",
          to: "/firm-order"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('発注一覧ページに切り替え')), 1)
          ], undefined, true),
          _: 1
        }),
        _createVNode(SvgLoader, {
          class: "unmatched-order-nav__icon",
          name: "orderSwitchIcon"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(FilterModalButton, {
            "filter-modal-type": 'unmatchedOrder',
            onApply: _unref(onAppliedFilterModal)
          }, null, 8, ["onApply"]),
          _createVNode(TextButton, {
            "button-style": 'btn-primary',
            size: 'btn-md',
            disabled: !hasSingleChecked.value,
            "on-click": _unref(openMatchModal),
            class: "bulk-action-button-container__button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('突合ボタン')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled", "on-click"]),
          _createVNode(TextButton, {
            "button-style": 'btn-primary',
            size: 'btn-md',
            disabled: !hasChecked.value,
            "on-click": onClickRegisterButton,
            class: "bulk-action-button-container__button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('新規登録ボタン')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(TextButton, {
            "button-style": 'btn-error',
            size: 'btn-md',
            disabled: !hasChecked.value,
            "on-click": _unref(deleteChecked),
            class: "bulk-action-button-container__button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('削除ボタン')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled", "on-click"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Pagination, {
            "paging-options": _unref(state).pagingOption,
            "is-loading": _unref(state).loadingStatus.type === 'loading',
            onOnChangePage: _unref(onChangedPaging)
          }, null, 8, ["paging-options", "is-loading", "onOnChangePage"])
        ])
      ]),
      _createVNode(EzTable, {
        "grid-template-columns": gridTemplateColumns.value,
        "sticky-header": "",
        "loading-status": _unref(state).loadingStatus,
        "max-height": "calc(100vh - 200px)",
        class: "base-table-wrapper"
      }, {
        header: _withCtx(() => [
          _createVNode(EzHeader, {
            "force-center": "",
            class: "table-checkbox"
          }, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                type: "checkbox",
                class: "unmatched-checkbox",
                checked: isAllChecked.value,
                indeterminate: hasChecked.value && !isAllChecked.value,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleCheckAll)()))
              }, null, 40, _hoisted_9)
            ], undefined, true),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayHeader.value.slice(1, -1), (header) => {
            return (_openBlock(), _createBlock(EzHeader, {
              key: `header:${header.key}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(header.label)), 1)
              ], undefined, true),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(EzHeader, { sticky: "right" }, {
            default: _withCtx(() => [
              _createVNode(TableHeaderModifyButton, {
                "modifiable-header-list": modifiableHeaderList.value,
                onToggle: _unref(updateDisplayHeader)
              }, null, 8, ["modifiable-header-list", "onToggle"])
            ], undefined, true),
            _: 1
          })
        ]),
        body: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).items, (item, index) => {
            return (_openBlock(), _createBlock(EzTableRow, {
              key: item.unmatchedOrderId,
              "grid-template-columns": gridTemplateColumns.value,
              "is-highlighted": _unref(state).checkedIds.includes(item.unmatchedOrderId),
              class: "unmatched-row"
            }, {
              default: _withCtx(() => [
                _createVNode(EzCell, {
                  "force-center": "",
                  class: "table-checkbox"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "unmatched-checkbox",
                      checked: _unref(state).checkedIds.includes(item.unmatchedOrderId),
                      onChange: ($event: any) => (_unref(toggleCheck)(item.unmatchedOrderId))
                    }, null, 40, _hoisted_10)
                  ], undefined, true),
                  _: 2
                }, 1024),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayHeader.value, (header) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `row:${header.key}:${index}`
                  }, [
                    (header.key === 'orderStatus')
                      ? (_openBlock(), _createBlock(EzCell, {
                          key: 0,
                          "force-center": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_11, [
                              _createVNode(OrderStatusBadge, {
                                "order-status-str": item.orderStatus
                              }, null, 8, ["order-status-str"])
                            ])
                          ], undefined, true),
                          _: 2
                        }, 1024))
                      : (header.key === 'errorReason')
                        ? (_openBlock(), _createBlock(EzCell, {
                            key: 1,
                            ref_for: true,
                            ref_key: "errorReasonTableCellRef",
                            ref: errorReasonTableCellRef
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)(_unref(ERROR_REASON_LABELS)[item.errorReason] ?? _unref(ERROR_REASON_LABELS).unknown)), 1)
                            ], undefined, true),
                            _: 2
                          }, 1536))
                        : (header.type === 'num')
                          ? (_openBlock(), _createBlock(EzCell, {
                              key: 2,
                              "is-number": ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item[header.key]?.toLocaleString() ?? ''), 1)
                              ], undefined, true),
                              _: 2
                            }, 1024))
                          : (header.type === 'date')
                            ? (_openBlock(), _createBlock(EzCell, {
                                key: 3,
                                "is-number": ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item[header.key] ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(item[header.key]) : ''), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024))
                            : (header.type === 'str')
                              ? (_openBlock(), _createBlock(EzCell, {
                                  key: 4,
                                  "is-number": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item[header.key] ?? ''), 1)
                                  ], undefined, true),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createVNode(EzCell)
              ], undefined, true),
              _: 2
            }, 1032, ["grid-template-columns", "is-highlighted"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["grid-template-columns", "loading-status"])
    ]),
    _createVNode(MatchConfirmModal, {
      "modal-state": _unref(state).matchModalState,
      "checked-items": checkedItems.value,
      onCanceled: _unref(closeMatchModal),
      onConfirm: _unref(matchChecked)
    }, null, 8, ["modal-state", "checked-items", "onCanceled", "onConfirm"]),
    _createVNode(RegisterOrderBusinessModal, {
      "modal-state": _unref(state).registerModalState,
      item: checkedItems.value[0],
      onClose: onCloseRegisterOrderBusinessModal
    }, null, 8, ["modal-state", "item"]),
    _createVNode(BulkRegisterModal)
  ]))
}
}

})